import type { KyInstance } from "ky";

export interface SubscribeNewsletterRequest {
  email: string;
}

export class NewsletterApi {
  constructor(private readonly http: KyInstance) { }

  /** Public — the footer signup. Succeeds for an address that is already subscribed. */
  subscribe = async (body: SubscribeNewsletterRequest): Promise<void> => {
    await this.http.post("newsletter/subscribers", { json: body });
  };
}
